import { PICTREE } from "../../constants";

const initialHomePhotoShoot = {
  countDenchu: 'loading',
  countUniqueUser: 'loading',
  countNewUser: 'loading',
  countPic: 'loading',
  countAsset: 'loading',
  countDupeDenchu: 'loading',
  countReviewOk: 'loading',
  progressDenchu: { taken: 0, max: 0, maxByasset: 0 },
  timings: {}, // {key: ms}
  errors:  {}, // {key: message}
};

const initialState = {
  homeDataUser: {},
  homeDataCheckIn: {},
  homeDataPhotoShoot: initialHomePhotoShoot,
  dataPhotoShootByAsset: [],
  photoShootTrendByAsset: [],
  homeDataReportTsuru: {},
  homeDataPhotoShootBySeason: {},
  homeDataReportStats: {},
  dataPhotoShootDetails: [],
  registTrend: [],
  registTable: [],
  usersOverview: [],
  usersList: [],
  userPageNumber: 1,
  salesOverview: [],
  salesTrend: [],
  salesTable: [],
  pointOverview: [],
  pointTrend: [],
  pointTable: [],
  pointExchangeData: [],
  pointExchangePageNumber: 1,
  checkInTrend: [],
  dataCheckInMap: [],
  dataCheckInTable: [],
  pictreeView: null,
  photoShootTrend: [],
  photoShootDenchuKaisuTrend: [],
  reportTsuruTrend: [],
  reportTrend: [],
  chartSize: "day",
  mapType: "taken",
  mapAssetSubTypeOption: [{ name: `全て`, value: "all" }],
  mapAssetSubType: "all",
  photoShootMapData: [],
  realTimeMapData: [[], []],
  byAreaDataSummary: [],
  byAreaDataTable: [],
  missionData: [],
  missionSummaryDataByMissionId: [],
  missionSummaryData: {},
  missionRankingData: [],
  missionDailyUsersById: [],
  photoShootRankingData: [],
  photoFirstShootRankingData: [],
  seasonRankingData: [],
  areaRankingData: [],
  rewardCoinSummaryData: {},
  rewardCoinData: [],
  rewardCoinRankingData: [],
  rewardedCoinData: [],
  periodType: "season",
  selectedSeason: [],
  seasonData: [],
  allSeasonData: [],
  selectedMission: "blank",
  adIds: [],
  adIdSelected: "all",
  adSummary: [],
  adTrend: [],
  goldChestOverview: [],
  goldChestTrend: [],
  chestType: "gold",
  rainbowListDetail: [],
  latLonByPowerAssetId: [],
};

export default function pictreeReducer(state = initialState, action) {
  switch (action.type) {
    case PICTREE.SET_HOME_USER:
      return {
        ...state,
        homeDataUser: action.payload,
      };
    case PICTREE.SET_HOME_CHECKIN:
      return {
        ...state,
        homeDataCheckIn: action.payload,
      };
    case PICTREE.SET_HOME_PHOTOSHOOT:
      return {
        ...state,
        homeDataPhotoShoot: action.payload,
      };
    case PICTREE.PATCH_HOME_PICTREE_PHOTO_SHOOT:
      return {
        ...state,
        homeDataPhotoShoot: {
          ...state.homeDataPhotoShoot,
          // 直下の key（countDenchu など）はそのまま上書き
          ...action.payload,
          // ネストは個別にマージ
          progressDenchu: {
            ...(state.homeDataPhotoShoot.progressDenchu || {}),
            ...(action.payload.progressDenchu || {}),
          },
          timings: {
            ...(state.homeDataPhotoShoot.timings || {}),
            ...(action.payload.timings || {}),
          },
          errors: {
            ...(state.homeDataPhotoShoot.errors || {}),
            ...(action.payload.errors || {}),
          },
        },
      };
    case PICTREE.SET_PHOTOSHOOT_BY_ASSET_TEPCO:
      return {
        ...state,
        dataPhotoShootByAsset: action.payload,
      };
    case PICTREE.SET_PHOTOSHOOT_TREND_BY_ASSET_TEPCO:
      return {
        ...state,
        photoShootTrendByAsset: action.payload,
      };
    case PICTREE.SET_HOME_REPORT_STATS:
      return {
        ...state,
        homeDataReportStats: action.payload,
      };
    case PICTREE.SET_HOME_REPORT_TSURU:
      return {
        ...state,
        homeDataReportTsuru: action.payload,
      };
    case PICTREE.SET_HOME_PHOTOSHOOT_BY_SEASON:
      return {
        ...state,
        homeDataPhotoShootBySeason: action.payload,
      };
    case PICTREE.SET_PHOTOSHOOT_DETAILS:
      return {
        ...state,
        dataPhotoShootDetails: action.payload,
      };
    case PICTREE.SET_REGIST_TREND:
      return {
        ...state,
        registTrend: action.payload,
      };
    case PICTREE.SET_REGIST_TABLE:
      return {
        ...state,
        registTable: action.payload,
      };
    case PICTREE.SET_SALES_OVERVIEW:
      return {
        ...state,
        salesOverview: action.payload,
      };
    case PICTREE.SET_SALES_TREND:
      return {
        ...state,
        salesTrend: action.payload,
      };
    case PICTREE.SET_SALES_TABLE:
      return {
        ...state,
        salesTable: action.payload,
      };
    case PICTREE.SET_POINT_OVERVIEW:
      return {
        ...state,
        pointOverview: action.payload,
      };
    case PICTREE.SET_POINT_TREND:
      return {
        ...state,
        pointTrend: action.payload,
      };
    case PICTREE.SET_POINT_TABLE:
      return {
        ...state,
        pointTable: action.payload,
      };
    case PICTREE.SET_POINT_EXCHANGE_DATA:
      return {
        ...state,
        pointExchangeData: action.payload,
      };
    case PICTREE.SET_POINT_EXCHANGE_PAGE_NUMBER:
      return {
        ...state,
        pointExchangePageNumber: action.payload,
      };
    case PICTREE.SET_CHECKIN_TREND:
      return {
        ...state,
        checkInTrend: action.payload,
      };
    case PICTREE.SET_CHECKIN_MAP:
      return {
        ...state,
        dataCheckInMap: action.payload,
      };
    case PICTREE.SET_CHECKIN_TABLE:
      return {
        ...state,
        dataCheckInTable: action.payload,
      };
    case PICTREE.SET_PICTREE_VIEW:
      return {
        ...state,
        pictreeView: action.payload,
      };
    case PICTREE.SET_PHOTOSHOOT_TREND:
      return {
        ...state,
        photoShootTrend: action.payload,
      };
    case PICTREE.SET_PHOTOSHOOT_DENCHU_KAISU_TREND:
      return {
        ...state,
        photoShootDenchuKaisuTrend: action.payload,
      };
    case PICTREE.SET_REPORT_TSURU_TREND:
      return {
        ...state,
        reportTsuruTrend: action.payload,
      };
    case PICTREE.SET_REPORT_TREND:
      return {
        ...state,
        reportTrend: action.payload,
      };
    case PICTREE.SET_USER_LIST:
      return {
        ...state,
        usersList: action.payload,
      };
    case PICTREE.SET_PICTREE_USER_PAGE_NUMBER:
      return {
        ...state,
        userPageNumber: action.payload,
      };
    case PICTREE.SET_CHART_SIZE:
      return {
        ...state,
        chartSize: action.payload,
      };
    case PICTREE.SET_MAP_TYPE:
      return {
        ...state,
        mapType: action.payload,
      };
    case PICTREE.SET_MAP_ASSET_SUB_TYPE_OPTION:
      return {
        ...state,
        mapAssetSubTypeOption: action.payload,
      };
    case PICTREE.SET_MAP_ASSET_SUB_TYPE:
      return {
        ...state,
        mapAssetSubType: action.payload,
      };
    case PICTREE.SET_PHOTOSHOOT_MAP_DATA:
      return {
        ...state,
        photoShootMapData: action.payload,
      };
    case PICTREE.SET_REALTIME_MAP_DATA:
      return {
        ...state,
        realTimeMapData: action.payload,
      };
    case PICTREE.SET_BY_AREA_DATA_SUMMARY_TEPCO:
      return {
        ...state,
        byAreaDataSummary: action.payload
      };
    case PICTREE.SET_BY_AREA_DATA_TABLE_TEPCO:
      return {
        ...state,
        byAreaDataTable: action.payload
      };
    case PICTREE.SET_MISSION_DATA:
      return {
          ...state,
          missionData: action.payload
      };
    case PICTREE.SET_MISSION_DATA_BY_MISSION_ID:
      return {
          ...state,
          missionSummaryDataByMissionId: action.payload
      };
    case PICTREE.SET_MISSION_SUMMARY_DATA:
      return {
          ...state,
          missionSummaryData: action.payload
      };
    case PICTREE.SET_MISSION_RANKING_DATA:
      return {
          ...state,
          missionRankingData: action.payload
      };
    case PICTREE.SET_MISSION_DAILY_USERS_BY_MISSION_ID:
      return {
          ...state,
          missionDailyUsersById: action.payload
      };
    case PICTREE.SET_PHOTO_SHOOT_RANKING_DATA:
      return {
          ...state,
          photoShootRankingData: action.payload
      };
    case PICTREE.SET_PHOTO_FIRST_SHOOT_RANKING_DATA:
      return {
          ...state,
          photoFirstShootRankingData: action.payload
      };
    case PICTREE.SET_SEASON_RANKING_DATA:
      return {
          ...state,
          seasonRankingData: action.payload
      };
    case PICTREE.SET_AREA_RANKING_DATA:
      return {
          ...state,
          areaRankingData: action.payload
      };
    case PICTREE.SET_REWARD_COIN_SUMMARY_DATA:
      return {
          ...state,
          rewardCoinSummaryData: action.payload
      };
    case PICTREE.SET_REWARD_COIN_DATA:
      return {
          ...state,
          rewardCoinData: action.payload
      };
    case PICTREE.SET_REWARD_COIN_RANKING_DATA:
      return {
          ...state,
          rewardedCoinData: action.payload
      };
    case PICTREE.SET_REWARDED_COIN_DATA:
      return {
          ...state,
          rewardCoinRankingData: action.payload
      };
    case PICTREE.SET_PERIOD_TYPE:
      return {
          ...state,
          periodType: action.payload
      };
    case PICTREE.SET_SELECTED_SEASON:
      return {
          ...state,
          selectedSeason: action.payload
      };
    case PICTREE.SET_SEASON_DATA:
      return {
          ...state,
          seasonData: action.payload
      };
    case PICTREE.SET_ALL_SEASON_DATA:
      return {
          ...state,
          allSeasonData: action.payload
      };
    case PICTREE.SET_MISSION_DATA:
      return {
          ...state,
          missionData: action.payload
      };
    case PICTREE.SET_SELECTED_MISSION:
      return {
          ...state,
          selectedMission: action.payload
      };
    case PICTREE.SET_AD_IDS:
      return {
          ...state,
          adIds: action.payload
      };
    case PICTREE.SET_AD_ID_SELECTED:
      return {
          ...state,
          adIdSelected: action.payload
      };
    case PICTREE.SET_AD_SUMMARY:
      return {
          ...state,
          adSummary: action.payload
      };
    case PICTREE.SET_AD_TREND:
      return {
          ...state,
          adTrend: action.payload
      };
    case PICTREE.SET_GOLD_CHEST_STATS:
      return {
          ...state,
          goldChestOverview: action.payload
      };
    case PICTREE.SET_GOLD_CHEST_TREND:
      return {
          ...state,
          goldChestTrend: action.payload
      };
    case PICTREE.SET_CHEST_TYPE:
      return {
          ...state,
          chestType: action.payload
      };
    case PICTREE.SET_RAINBOW_LIST_DETAIL:
      return {
          ...state,
          rainbowListDetail: action.payload
      };
    case PICTREE.SET_LAT_LON_BY_POWER_ASSET_ID:
      return {
          ...state,
          latLonByPowerAssetId: action.payload
      };
    default:
      return state;
  }
}
